export default __webpack_public_path__ + "static/media/russian poker-01.ab026eb8.png";